import saveAs from 'file-saver';
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import Button from './Button/Button';

export default function QrCodeWithDownload({
  content,
  fileName,
  close,
}: {
  content: string;
  fileName: string;
  close: (params: boolean) => void;
}) {
  const [qrCodeData, setQrCodeData] = useState(null as string | null);
  useEffect(() => {
    async function generateQR() {
      setQrCodeData(await QRCode.toDataURL(content, { scale: 7 }));
    }
    generateQR();
  }, [content]);

  if (!qrCodeData) {
    return null;
  }

  return (
    <>
      <div className={'flex justify-center'}>
        <img src={qrCodeData} alt='Sharing QR code' />
      </div>
      <div className={'grid grid-cols-2 gap-4'}>
        <Button variant={'secondary'} onClick={() => close(true)}>
          Back
        </Button>
        <Button
          variant={'primary'}
          onClick={() => saveAs(qrCodeData, fileName)}
        >
          Download QR code
        </Button>
      </div>
    </>
  );
}
